import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Capability } from 'src/app/models/service/capability';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { translate } from '@jsverse/transloco';
import { MatDialog } from '@angular/material/dialog';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  }
];
@Component({
    selector: 'app-capability-details',
    templateUrl: './capability-details.component.html',
    styleUrls: ['./capability-details.component.scss'],
    standalone: false
})
export class CapabilityDetailsComponent implements OnInit {
  @Output() selectionChanged = new EventEmitter();

  mockedDocumentationData = [
    {
      title: 'Overview',
    },
    {
      title: 'Additional Capabilities',
    },
    // {
    //   title: 'User Guides',
    // },
    // {
    //   title: 'Integrations',
    // },
    // {
    //   title: 'Pricing',
    // },
    // {
    //   title: 'Release Notes',
    // }
  ];

  capability: Capability;
  selectable = true;
  description: string;
  version: any;
  releaseVersion: any;
  capabiltyDisabled: any;
  isAMR: any;
  selectedDocumentation: string;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  additionalCapabilties: any;
  selectedCapability: any;
  Capability: any;
  mainArray: any;
  additionalIncluded = [];
  additionalOptional = [];
  isOverview = true;
  isCapabilities = false;
  nestedCapabilities: any;



  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private toastrService: ToastrService,
    private solutionVersionsService: SolutionVersionsService,
    public matdialogRef: MatDialogRef<CapabilityDetailsComponent>, private dialog: MatDialog,private permissionsService: PermissionsService) {
    this.capability = data.capability;
    this.description = this.capability.description;
    this.nestedCapabilities = this.capability?.nestedObj;
    this.version = data.version;
    this.releaseVersion = data.releaseVersion;
    this.capabiltyDisabled = data.capabiltyDisabled;
    if (data.selectable != null) {
      this.selectable = data.selectable;
    }
    this.selectedDocumentation = this.mockedDocumentationData[0].title;
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
      this.isAMR = true;
    }

  }

  selectDocumentation(documentation: any): void {
    this.selectedDocumentation = documentation.title;
    if (this.selectedDocumentation === 'Overview') {
      this.isOverview = true;
      this.isCapabilities = false;
    } else {
      this.isOverview = false;
      this.isCapabilities = true;
    }
  }

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
    this.selectionChangedData(this.capability);
    this.matdialogRef.close(this.capability);
  }

  selectionChangedData(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    this.toastrService.clear();
  }

  titleCaseWord(word): void {
    if (!word) { return word; }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

}
